import {applyMiddleware, combineReducers, compose, createStore} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import { getProductDetailsReducer, getProductReducer } from './reducers/productReducers';
import { cartReducer } from './reducers/cartReducer';

const reducer=combineReducers({
    getProducts:getProductReducer,
    getProductDetails:getProductDetailsReducer,
    cart:cartReducer
});

// const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// export const store = createStore(rootReducer, composeEnhancer(applyMiddleware(thunk)))

const middleware=[thunk];
const store=createStore(
    reducer,
    composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
